module.exports = __webpack_public_path__ + "img/2.d456e354.png";